<div class="table-controls">
  <!-- Search -->
  <div class="search-group">
    <label [attr.for]="'table-search-' + instanceId" class="control-label">Search</label>
    <div class="search-input-wrapper">
      <lucide-angular class="search-icon" name="search" [size]="14" aria-hidden="true"></lucide-angular>
      <input [id]="'table-search-' + instanceId" type="text" class="search-input"
        [placeholder]="searchPlaceholder" [ngModel]="searchTerm" (ngModelChange)="searchChange.emit($event)"
        [disabled]="disabled" autocomplete="off" />
    </div>
  </div>

  <!-- Show rows selector -->
  <div class="rows-selector">
    <label [attr.for]="'show-rows-' + instanceId" class="control-label">Show rows</label>
    <select [id]="'show-rows-' + instanceId" class="rows-select" [ngModel]="pageSize" (ngModelChange)="pageSizeChange.emit($event)"
      [disabled]="disabled">
      <option *ngFor="let size of pageSizeOptions" [ngValue]="size">{{ size }}</option>
    </select>
  </div>

  <!-- Selection controls (visible only when rows are selected) -->
  <ng-container *ngIf="selectedCount > 0">
    <button type="button" class="btn-toolbar-icon" (click)="moveDown.emit()"
      [disabled]="disabled || selectedCount !== 1 || !canMoveDown" aria-label="Move selected row down" title="Move down">
      <lucide-angular name="chevron-down" [size]="14" aria-hidden="true"></lucide-angular>
    </button>
    <button type="button" class="btn-toolbar-icon" (click)="moveUp.emit()"
      [disabled]="disabled || selectedCount !== 1 || !canMoveUp" aria-label="Move selected row up" title="Move up">
      <lucide-angular name="chevron-up" [size]="14" aria-hidden="true"></lucide-angular>
    </button>

    <div class="move-to-group">
      <label [attr.for]="'move-to-pos-' + instanceId" class="sr-only">Move to row number</label>
      <input [id]="'move-to-pos-' + instanceId" type="number" class="move-to-input" min="1" [max]="totalRows"
        [(ngModel)]="moveToTarget" placeholder="" aria-label="Move to row number" [disabled]="disabled" />
      <button type="button" class="btn-move" (click)="submitMoveToPosition()"
        [disabled]="disabled || selectedCount !== 1 || !moveToTarget" aria-label="Move row">
        Move
      </button>
    </div>

    <button type="button" class="btn-delete" (click)="deleteSelected.emit()"
      [disabled]="disabled" aria-label="Delete selected rows" title="Delete selected">
      <lucide-angular name="trash-2" [size]="14" aria-hidden="true"></lucide-angular>
    </button>

    <div class="selection-info" aria-live="polite">
      <span class="selection-count">{{ selectedCount }}</span>
      <span class="selection-label">Selected</span>
    </div>
  </ng-container>

  <!-- Clear selection: visible when rows selected OR cell range active -->
  <button *ngIf="(selectedCount > 0 || hasCellRange) && editable && !readonly"
    type="button" class="btn-clear-selection" (click)="clearSelection.emit()"
    [disabled]="disabled" aria-label="Clear cell values in selection" title="Clear selection">
    <lucide-angular name="eraser" [size]="14" aria-hidden="true"></lucide-angular>
    <span>Clear</span>
  </button>

  <!-- Spacer -->
  <div class="controls-spacer"></div>

  <!-- Import dropdown (disclosure button pattern — Tab-navigable) -->
  <div class="import-dropdown" *ngIf="editable && !readonly"
    (focusout)="onDropdownFocusOut($event)">
    <button type="button" class="btn-import" [class.open]="importMenuOpen"
      (click)="toggleImportMenu()" (keydown)="onTriggerKeydown($event)"
      [disabled]="disabled" aria-haspopup="true" [attr.aria-expanded]="importMenuOpen"
      [attr.aria-controls]="importMenuOpen ? 'import-menu-' + instanceId : null"
      aria-label="Import options">
      <lucide-angular name="upload" [size]="14" aria-hidden="true"></lucide-angular>
      <span>Import</span>
      <lucide-angular class="dropdown-arrow" name="chevron-down" [size]="10" aria-hidden="true"></lucide-angular>
    </button>
    <div class="import-menu" *ngIf="importMenuOpen"
      [id]="'import-menu-' + instanceId"
      (keydown)="onImportMenuKeydown($event)">
      <button type="button" class="import-option"
        (click)="triggerImport(); closeImportMenu()">Import</button>
      <button type="button" class="import-option"
        (click)="downloadTemplate(); closeImportMenu()">Template</button>
    </div>
  </div>
</div>
